import React from 'react'
import PropTypes from 'prop-types'

function convertParams (params) {
    return {...params}
}

function convertSearch (search) {
    let params = {}

    for (let [key, value] of new URLSearchParams(search)) {
        params[key] = value
    }

    return params
}

function connectUrl (mapParamsToProps) {
    return function (WrappedComponent) {
        class ConnectUrl extends React.Component {
            constructor (props) {
                super(props)

                this.state = {
                    wrappedProps: mapParamsToProps(
                        convertParams(this.props.match.params),
                        convertSearch(this.props.location.search)
                    ),
                    location: this.props.location,
                }

                this.push = this.push.bind(this)
            }

            static getDerivedStateFromProps (nextProps, { location }) {
                const locationChanged = nextProps.location !== location

                if (locationChanged) {
                    return {
                        location: nextProps.location,
                        wrappedProps: mapParamsToProps(
                            convertParams(nextProps.match.params),
                            convertSearch(nextProps.location.search)
                        ),
                    }
                }

                return null
            }

            push (...args) {
                this.props.history.push(...args)
            }

            render () {
                return (
                    <WrappedComponent
                      {...this.props}
                      {...this.state.wrappedProps}
                      push={this.push}
                    />
                )
            }
        }

        ConnectUrl.propTypes = {
            match: PropTypes.object.isRequired,
            location: PropTypes.object.isRequired,
            history: PropTypes.object.isRequired,
        }

        return ConnectUrl
    }
}

export default connectUrl
